module.exports = __webpack_public_path__ + "static/media/ongoing_dot.8a377008.svg";